import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// @Utility
import setBodyScroll from "./../../../../@utility/app/setBodyScroll";

//  CSS
import styles from "./../assets/css/Style.module.css";

export default function ClosePage({ backPage }) {
    const [page, setPage] = useState("/");
    // let setPage = page;
    const history = useHistory();

    const closePage = () => {
        if (backPage !== undefined && backPage !== null) {
            setBodyScroll(false);
            history.push(page);
        }
    };

    useEffect(() => {
        setPage(backPage);
    }, [backPage]);

    return <img className={styles.iconClose} src="/images/game/btn_close_circle.webp" alt=" เว็บออนไลน์ที่ให้บริการครบวงจร พร้อมโปรโมชั่นสุดพิเศษรองรับทุกการเสี่ยงโชค สมัครวันนี้รับโบนัสต้อนรับสูงสุด พร้อมระบบฝาก-ถอน อัตโนมัติที่รวดเร็วและปลอดภัยตลอด 24 ชม." onClick={() => closePage()} />;
}